import { bold, cyan } from '@ms-cloudpack/task-reporter';

/**
 * Handle known parse https errors.
 */
export function handleKnownParseHttpsErrors(params: { err: unknown; projectName: string }): void {
  const { err } = params;
  if (!err || !(err instanceof Error)) {
    // If the error is not an instance of Error, we can't handle it.
    return;
  }

  // If a known error occurs, we can provide a more user-friendly message.
  // and we can also suppress the stack trace for these errors because it's not useful to the user.
  if (err.message.startsWith('The specified certificate to be used for the web server is missing')) {
    err.message = `Cloudpack could not start because ${lowerCaseFirstLetter(err.message)}`;
    err.stack = undefined;
  } else if (err.message.startsWith('No certificate found for the domain')) {
    err.message =
      `The local site is configured to use https in cloudpack.config.json, but is missing a cert.\n\n` +
      `Run "${cyan(bold('cloudpack setup'))}" to create the required certificate and try start again.`;
    err.stack = undefined;
  } else if (err.message === 'Must provide at least one domain in "domain" option to get certificate paths.') {
    err.message = `Cloudpack could not start because the "domain" option was not provided or was empty. \nThis is a Cloudpack bug, please report it!`;
  }
}

function lowerCaseFirstLetter(str: string): string {
  return str.charAt(0).toLowerCase() + str.slice(1);
}
